export type AgentSessionTab =
  'live-watch' | 'recording' | 'screenshots' | 'events';

export function defaultAgentSessionTab(options: {
  isComplete: boolean;
  showRecording: boolean;
  showScreenshots: boolean;
  showEvents: boolean;
}): AgentSessionTab {
  if (!options.isComplete) return 'live-watch';
  if (options.showRecording) return 'recording';
  if (options.showScreenshots) return 'screenshots';
  if (options.showEvents) return 'events';
  return 'screenshots';
}

export function resolveAgentSessionTab(options: {
  activeTab: AgentSessionTab;
  showLiveWatch: boolean;
  showRecording: boolean;
  showScreenshots: boolean;
  showEvents: boolean;
}): AgentSessionTab {
  const visible: Record<AgentSessionTab, boolean> = {
    'live-watch': options.showLiveWatch,
    recording: options.showRecording,
    screenshots: options.showScreenshots,
    events: options.showEvents,
  };
  if (visible[options.activeTab]) return options.activeTab;
  if (options.showLiveWatch) return 'live-watch';
  if (options.showRecording) return 'recording';
  if (options.showScreenshots) return 'screenshots';
  if (options.showEvents) return 'events';
  return 'screenshots';
}

export function shouldRenderAgentSessionViewer(options: {
  showLiveWatch: boolean;
  showRecording: boolean;
  showScreenshots: boolean;
  showEvents: boolean;
}): boolean {
  return (
    options.showLiveWatch ||
    options.showRecording ||
    options.showScreenshots ||
    options.showEvents
  );
}
